<template>
    <div 
        id="AppartDetails"
        v-bind:appartData="appartData"
        v-bind:okanMain="okanMain"
        v-bind:params="params"
    >
        <div 
            v-bind:class="{'reduced':okanMain.showThree}"
            id="backgroundDetails"
            v-if="!okanMain.fromURL"
        >
            <div 
                id="isoContainer" @mousewheel="zoom"
                    v-bind:style="divStyle"
                > 
                <div id="compassContainer" class="details" v-show="okanMain.params.boussole">
                    <div id="north"></div>
                    <div id="compass" class="details" v-bind:style="getRotation()"></div>
                </div>                
                
            </div>
        </div> 

        <threejs
            id="threeDiv"
            v-show="okanMain.showThree"
            v-if="okanMain.selectedAppart!=null && appartData.sphereID != null"
            v-bind:okanMain="okanMain"
            v-bind:appartData="appartData"
            v-bind:showThree="okanMain.showThree"
        /> 

        <div id="buttonsDiv" v-if="!okanMain.fromURL">
            <span 
                v-bind:class="{'hide':okanMain.showThree}" 
                id="flatTitle">Lot : {{appartData.appartName}}
            </span>
            <div id="leftButtonsDiv">
                <div class="buttonWrapper">
                    <div 
                        id="btnBack" 
                        @click="goBack"
                        v-bind:class="{'three':okanMain.showThree}"
                    ></div>
                </div>
                <div class="buttonWrapper"
                    v-show="okanMain.threeScene != null && okanMain.threeScene.visits != null &&  appartData.appartID == okanMain.threeScene.visits.spheres[appartData.sphereID].AppID"
                >
                    <div 
                        id="btnToggle" 
                        @click="toggleThree"
                        v-bind:class="{'three':okanMain.showThree}"
                        v-show="okanMain.threeScene != null && okanMain.threeScene.visits != null &&  appartData.appartID == okanMain.threeScene.visits.spheres[appartData.sphereID].AppID"

                    >
                        <!--<span v-show="okanMain.showThree">Voir le plan<br/>en 3D</span>-->
                    </div>  
                </div>
              
            </div>


        </div>   

        <div 
            id="aide"
            v-show="!okanMain.showThree"
        >
            <div class="help" @click="showHelp = !showHelp"></div>
            <div class="helpDiv" v-show="showHelp">
            <span class="rightSpan1">Molette pour zoomer</span>
            <br />
            <span class="rightSpan2">Clic gauche maintenu pour déplacer</span>
            </div>
       
        </div>   

    <div id="mentionsLegout" v-show="!okanMain.showThree && !showHelp">
      <span><i>* Visuels non contractuels, illustrations à caractère d'ambiance.</i></span><br/>
      <span class="rightAlign"><i>  Réalisation <a href="http://www.okan3d.com" target="_blank">Okénite Animation</a></i></span>
    </div>          

    </div>

</template>

<script>

import threejs from "../components/three"

export default {
  name: 'AppartDetails',
  components: {
    threejs
  },
  props: {
      okanMain : Object,
      appartData: Object,
      params: Object
  },
  data() {
    return {
        showThree : false,
        mousedown : false,
        mousePos: null,
        divStyle : {
            top:0,
            left:0,
            transform:"",
            'background-image': '',
            'background-repeat': 'no-repeat',
            'background-position': 'center center',
            'background-attachment': 'local',
            'background-size': 'contain', //this.okanMain.zoomLevel + '% ' + this.okanMain.zoomLevel + '%' ,
            'background-color': 'white',             
        },
        zoomLevel: 100,
        showHelp: false,

    }
  },
  methods: {
      goBack(){
          this.okanMain.showThree = false;
          this.okanMain.showAppartDetails = false;
          this.okanMain.leftMouseButtonDown = false;
          this.okanMain.downGradeArianeLevel(0);
      },
      toggleThree(){
          this.okanMain.showThree = !this.okanMain.showThree;
      },
      getRotation(){
          var value = 0;
          if(this.appartData != null && this.appartData != undefined && isNaN(this.appartData.northDecay)){
              value = this.appartData.northDecay
          }
          return "transform:rotateZ(" + value + "deg)";
      },
      backgroundStyle(){
        if(!this.okanMain.fromURL){
            var image_name = "0000000000000000" + this.appartData.appartLink;
            image_name = image_name.substr(image_name.length - this.params.imagePlanCounterLength);
            var image_path = "img/plan/" + this.params.imagePlanPrefix + image_name + ".jpg";
            this.divStyle['background-image'] = "url("+  image_path +")";
            //return "background: url("+  image_path +"); ";  
        }
       
      },
      zoom(event){
          var delta = Math.sign(event.deltaY);
        if (delta > 0){
            this.zoomLevel = Math.max(50, this.zoomLevel - 10);
        }
        else{
            this.zoomLevel = Math.min(150, this.zoomLevel + 10);
        }
        this.divStyle.transform = "scale(" + this.zoomLevel /100 + ")"
      }, 

      drag(event){

          
          if(!this.mousedown){
            this.mousePos = {
                x: event.clientX,
                y: event.clientY
            }
          }
          else{
            
            var isoContainer = document.getElementById('isoContainer');
            var top=Number(isoContainer.style.top.substr(0,isoContainer.style.top.length -2 ));
            var left =Number(isoContainer.style.left.substr(0,isoContainer.style.left.length -2 ));

            top +=  event.clientY  - this.mousePos.y;
            left +=  event.clientX - this.mousePos.x;

            this.divStyle.top = top+'px';
            this.divStyle.left = left + 'px';

          }
            this.mousePos = {
                x: event.clientX,
                y: event.clientY
            }
      }
    
  },
  mounted() {
      this.backgroundStyle();
  }
}
</script>

<style src="../assets/css/details.css"></style>